export const normalizeKeyToCamelCase = (key: string): string => {
  if (key === 'IP') {
    return 'ipAddress'
  }

  if (/^[A-Z0-9_]+$/.test(key)) {
    return key.toLowerCase().replaceAll(/_([a-z0-9])/g, (_, char: string) => char.toUpperCase())
  }

  return key.replace(/^[A-Z]/, char => char.toLowerCase())
}

export const formatIpAddress = (rawIp?: unknown): string | undefined => {
  if (typeof rawIp !== 'number' || !Number.isFinite(rawIp)) {
    return undefined
  }

  const ip = rawIp >>> 0
  const octet1 = (ip >>> 24) & 255
  const octet2 = (ip >>> 16) & 255
  const octet3 = (ip >>> 8) & 255
  const octet4 = ip & 255

  return `${octet1}.${octet2}.${octet3}.${octet4}`
}
